import { ACFMediaFragment } from "@fragments";
import { gql } from "@apollo/client";

const RecentPostsQuery = gql`
  ${ACFMediaFragment}
  query RecentPosts($language: String) {
    posts(
      first: 10
      where: {status: PUBLISH, orderby: {field: DATE, order: DESC}, language: $language}
    ) {
      nodes {
        uri
        title
        pageData {
          featuredImage {
            ...ACFMedia
          }
        }
        featureData {
          excerpt
        }
      }
    }
  }
`;

export default RecentPostsQuery;